import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2, UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const ApproveDriver = () => {

  const {showModal, setShowModal, approveDriver, rejectDriver, isLoading, selectedService} = React.useContext(Context.ServiceScreen);
  const { t } = useTranslation();

  // ?? ================================================================================================================
  // ??                                              JSX Content
  // ?? ----------------------------------------------------------------------------------------------------------------

  return (
    <section id="school-approve-modal-container">
      <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "APPROVE_DIRVIER"} overlayClose>
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="approve-driver-text">
            <p>راننده‌ی این سرویس را تایید یا رد کنید</p>
            <br />
            <UserInformation
              avatar={selectedService?.student?.avatar}
              name={selectedService?.student?.firstName}
              lastName={selectedService?.student?.lastName}
              phoneNumber={selectedService?.student?.address}
              isBlock={selectedService?.student?.approved?.isApprove}
            />
          </CustomView.Row>
          <br/>
          <CustomView.Row className="form-row">
            <CustomView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2 isLoading={isLoading} onClick={rejectDriver} title={t("removeDriver")} type={"warning"} />
            </CustomView.Column>
            <CustomView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2 isLoading={isLoading} onClick={approveDriver} title={t("approve")} type={"primary"} />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ApproveDriver;
